// import actions
import reniecAction from './actions/reniec'
import rucAction from './actions/ruc'
import mtcAction from './actions/mtc'
import qrAction from './actions/qr'

const actions = {
  ...reniecAction, ...rucAction, ...mtcAction, ...qrAction,
}

export default {
  namespaced: true,
  actions,
}
